import { PropertyStripLayout } from '../../canvas/properties/PropertyStripLayout';
import { moreLayout } from '../../canvas/properties/TextPropertyStripParts';
import { Topic } from './Topic';
import { topicApplyAsTag, topicApplyColor, topicTidy } from './TopicCommands';

export const topicPropertyLayout = PropertyStripLayout<Topic>((d, s, o, w, a) => [
    //
    // Color
    w.createColorSelector({
        autoSelect: true,
        groups: true,
        value: a.get('color'),
        text: 'Topic Color',
        onSelect() {
            o.update(u => {
                u.rolling(a.keyFor('color'));
                a.set('color', this.value!);
            });
        }
    }),
    ...(a.count === 1 ? [
        w.createDivide(),
        // Color
        w.createButton({
            text: 'Apply Topic Color To Items',
            image: 'deqo://icons/deqo/topic-fill',
            onAction() {
                d(topicApplyColor, [a.first().id]);
            }
        }),
        // Tag
        w.createButton({
            text: 'Tag Items Using Topic Label',
            image: 'deqo://icons/hero/tag',
            onAction() {
                d(topicApplyAsTag, [a.first().id]);
            }
        }),
        // Tidy
        w.createButton({
            text: 'Tidy Items',
            image: 'deqo://icons/deqo/topic-tidy',
            onAction() {
                d(topicTidy, [a.first().id]);
            }
        }),
    ] : []),
    w.createDivide(),
    ...moreLayout(d, s, o, w, a),
]);
